import { useCallback, useEffect, useMemo, useState } from "react";

import { ReservationDetailCancelInputZodSchema, type ReservationDetailCancelInputType } from "./validation-schema";

import type { SafeParseError } from "zod";

export const useHandleFormState = (willCancelPrice: number | undefined) => {
	const [canceledPrice, setCanceledPrice] = useState<number | undefined>(willCancelPrice);
	/**
	 * キャンセル料金を更新
	 */
	const handleChangeCanceledPrice = useCallback((value: number | undefined) => {
		setCanceledPrice(value);
	}, []);

	const [validationErrors, setValidationErrors] = useState<
		SafeParseError<ReservationDetailCancelInputType> | undefined
	>(undefined);
	/**
	 * state の変更を監視し、バリデーションを実行
	 */
	useEffect(() => {
		const zodErrors = ReservationDetailCancelInputZodSchema.safeParse({ canceledPrice });

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	}, [canceledPrice]);

	const canceledPriceErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.canceledPrice?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.canceledPrice],
	);
	const hasError = useMemo(() => validationErrors !== undefined, [validationErrors]);

	return {
		canceledPrice,
		canceledPriceErrorMessage,
		hasError,
		//
		handleChangeCanceledPrice,
	};
};
